export default "__VITE_ASSET__Bp$s5cvF__"